import script from "./InventoryContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryContainer.vue?vue&type=script&setup=true&lang=js"

import "./InventoryContainer.vue?vue&type=style&index=0&id=7ab766b4&lang=css"

const __exports__ = script;

export default __exports__